import { setAuthInHeader } from "@/api";
import { GET_STATUS } from "@/components/utils.js";

const mutations = {
  LOGIN(state, resp) {
    /*
    로그인

    개요:
      store.state, localStorage에 각각 JWT토큰과 유저데이터를 저장한다.

    Args:
      resp(Object): 로그인 시 API 서버 반환값
        acessToken(String): JWT 토큰
        user(Object): 유저정보(ksia_member 테이블)
        user_db(Object): 유저정보(ksia_member_db 테이블)

    No results
    */
    if (!resp) return;
    state.token = resp.accessToken === "null" ? null : resp.accessToken;
    state.user = Object.assign({}, resp.user, resp.user_db);
    localStorage.setItem("token", state.token);
    localStorage.setItem("user", JSON.stringify(state.user));
    setAuthInHeader(state.token);
  },
  LOGOUT(state) {
    /*
    로그아웃

    개요: store.state, localStorage에 각각 JWT토큰과 유저데이터를 삭제한다.

    No args
    No results
    */
    state.token = null;
    state.user = null;
    localStorage.clear();
    setAuthInHeader(null);
  },
  SET_IS_ADD_CAMPAIGN(state, toggle) {
    /*
    캠페인 생성 모달

    개요: store.state.isAddCampaign의 값을 참 혹은 거짓으로 이벤트에 따라 수정하여
         모달을 띄울 수 있도록 하는 setter이다.

    Args: toggle(Boolean): True or False

    No results
    */
    state.isAddCampaign = toggle;
  },
  SET_IS_EDIT_CAMPAIGN(state, toggle) {
    /*
    캠페인 편집 모달 상태변환

    개요: store.state.isEditCampaign의 값을 참 혹은 거짓으로 이벤트에 따라 수정하여
         모달을 띄울 수 있도록 하는 setter이다.

    Args: toggle(Boolean): True or False

    No results
    */
    state.isEditCampaign = toggle;
  },

  SET_SCHEDULE(state, payload) {
    const header = [];
    const footer = [];

    for (let i = 0; i < payload.data.length; i++) {
      const { start_date, end_date } = payload.data[i];
      header.push(start_date);
      footer.push(end_date);
    }

    state.schdules = { header, footer };
  },

  SET_CAMPAIGNS(state, payload) {
    const campaigns = payload.map((item) => ({
      ...item,
      status: GET_STATUS(item.start_date, item.end_date),
    }));

    state.campaigns = campaigns;
  },
  SET_CAMPAIGN(state, campaign) {
    state.campaign = campaign;
    // console.log(state.campaign)
  },
  SET_ITEMS(state, items) {
    state.items = items;
  },
  SET_ITEM(state, item) {
    state.item = item;
  },

  SET_IS_SHOW_CAMPAIGN_SETTINGS(state, toggle) {
    state.isShowCampaignSettings = toggle;
  },

  SET_MANAGERS(state, managers) {
    state.managers = managers;
  },

  SET_USER_ADMIN(state, user) {
    state.admin.user = user;
  },

  SET_STATISTIC(state, statistic) {
    state.statistic = statistic;
  },

  SHOW_CONFIRM(state, payload) {
    state.confirm = { ...payload, show: true };
  },

  HIDE_CONFIRM(state) {
    state.confirm.show = false;

    setTimeout(() => {
      state.confirm = {
        title: null,
        content: null,
        onConfirm: () => {},
        onClose: null,
      };
    }, 250);
  },

  ADD_ALERTS(state, payload) {
    state.alerts.push(payload);
  },
  REMOVE_ALERTS(state, payload) {
    state.alerts = state.alerts.filter(({ uid }) => uid !== payload);
  },
};

export default mutations;
